import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { IoBarChart, IoClose } from "react-icons/io5";
import { PiPackageFill } from "react-icons/pi";
import { FaTruckMoving, FaPlaneDeparture,FaCalendarAlt} from "react-icons/fa";
import { AiFillNotification } from "react-icons/ai";
import { GrNotes } from "react-icons/gr";
import { TbPackages } from "react-icons/tb";
import { IoIosPeople } from "react-icons/io";
import { GrSettingsOption, GrUserWorker } from "react-icons/gr";
import { LuPackageCheck } from "react-icons/lu";
import { AiOutlineFileUnknown } from "react-icons/ai";
import { CgLogOut } from "react-icons/cg";
import { BiSolidReport } from "react-icons/bi";
import { MdMenuOpen } from "react-icons/md";
import logo from '../assets/images/4.png';

export default function Sidebar({ onDrawerToggle }) {
  const [open, setOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 799);
  const navigate = useNavigate();
  const { logout } = useAuth();
  const user = JSON.parse(localStorage.getItem('user'));

  const handleDrawerToggle = () => {
    setOpen(prevOpen => !prevOpen);
    onDrawerToggle(!open);
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 799;
      setIsMobile(mobile);
      setOpen(!mobile);
      onDrawerToggle(!mobile);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [onDrawerToggle]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = user.role == "Courier"
    ? [
        { text: 'Dashboard', route: '/dashboard', icon: <IoBarChart /> },
        { text: 'Users', route: '/users', icon: <PiPackageFill /> },
        // { text: 'Unknown Packages', route: '/unknown-packages', icon: <AiOutlineFileUnknown /> },
        // { text: 'Claims', route: '/claims', icon: <LuPackageCheck /> },
        { text: 'Signout', action: handleLogout, icon: <CgLogOut /> },
      ]
    : [
        { text: 'Dashboard', route: '/dashboard', icon: <IoBarChart /> },
        { text: 'Users', route: '/users', icon: <PiPackageFill /> },
        { text: 'Appointments', route: '/appointments', icon: <FaCalendarAlt /> },
        { text: 'Notification', route: '/notifications', icon: <AiFillNotification /> },
        // { text: 'Collections', route: '/collections', icon: <TbPackages /> },
        { text: 'Subscriptions', route: '/subscriptions', icon: <BiSolidReport /> },
        // { text: 'Staff', route: '/staff', icon: <GrUserWorker /> },
        // { text: 'Unknown Packages', route: '/unknown-packages', icon: <AiOutlineFileUnknown /> },
        // { text: 'Claims', route: '/claims', icon: <LuPackageCheck /> },
        // { text: 'Reports', route: '/reports', icon: <BiSolidReport /> },
        { text: 'Settings', route: '/settings', icon: <GrSettingsOption /> },
        { text: 'Signout', action: handleLogout, icon: <CgLogOut /> },
      ];

  return (
    <div className={`flex ${isMobile ? "fixed z-50" : "relative"} top-0 left-0`}>
    {/* Sidebar Overlay for Mobile */}
    {isMobile && open && (
      <div
        className="fixed inset-0 bg-black bg-opacity-50"
        onClick={() => setOpen(false)}
      />
    )}

    

    {/* Sidebar Container */}
    <div
      className={`${
        open ? "w-48" : "w-16"
      } bg-[#1A1A1A] text-white shadow-lg min-h-screen flex flex-col transition-all duration-300 overflow-x-auto`}
    >
      {/* Header */}
      <div className="bg-white px-4 py-4 flex items-center justify-between">
  <img src={logo} alt="Logo" className="w-36 object-contain transition-all" />
  <button
    onClick={() => setOpen(!open)}
    className="text-2xl text-black hover:text-gray-700"
  >
    {open ? "⟨" : "⟩"}
  </button>
</div>
      {/* User Info */}
     

      {/* Menu */}
      <ul className="flex flex-col gap-4 px-2 mt-4">
        {menuItems.map(({ text, route, icon, action }, index) => (
          <li key={index}>
            <NavLink
              to={route || "#"}
              onClick={action}
              className={({ isActive }) =>
                `flex items-center gap-4 px-4 py-3 rounded-lg transition-all duration-300 ${
                  isActive ? "bg-[#002D7E]" : "hover:bg-[#87D601]"
                }`
              }
            >
              <span className="text-2xl">{icon}</span>
              {open && <span className="font-medium">{text}</span>}
            </NavLink>
          </li>
        ))}
      </ul>

      
    </div>

  </div>
  );
}
